// LA UBICACIÓN SUGERIDA POR OMISIÓN · PLAN-DE-CIERRE-PILOTO P15 (29 sep 2026).
//
// EL PROBLEMA. Entrada, salida y traspaso pedían elegir la ubicación aunque
// el producto estuviera en un solo sitio: el selector nacía en «Selecciona
// ubicación…» y cada movimiento costaba un toque de más (LISTO-PARA-PILOTO
// j, hallazgo 2). El «Desde» ya se proponía por saldo (T-11); faltaba el
// «Hacia».
//
// LA REGLA, en este orden:
//   · ENTRADA: donde ya hay existencia de este producto (la de mayor saldo);
//     si no hay en ningún sitio, la última ubicación que usó esta persona en
//     este navegador.
//   · TRASPASO: la última que usó esta persona, si no es la misma de la que
//     sale; si no, otra ubicación con existencia distinta del origen; si no
//     hay ninguna, nada (un traspaso a ciegas no se propone).
// Es un punto de partida, no una imposición: se cambia en el selector.
//
// Se guarda EN EL NAVEGADOR y por persona: es una comodidad de quien usa
// ese teléfono, no un dato de la empresa. Si el almacenamiento no está
// (ventana privada, bloqueado), no pasa nada: no se sugiere la última.

const CLAVE = 'tego.movimiento.ultimaUbicacion';

const clave = (idUsuario) => `${CLAVE}.${idUsuario ?? 'sin-sesion'}`;

export function leerUltimaUbicacion(idUsuario) {
  try {
    return localStorage.getItem(clave(idUsuario)) || '';
  } catch {
    return '';
  }
}

export function guardarUltimaUbicacion(idUsuario, codigo) {
  if (!codigo) return;
  try {
    localStorage.setItem(clave(idUsuario), codigo);
  } catch {
    // Sin almacenamiento, la próxima vez simplemente no se propone.
  }
}

// `saldos`: {codigo: cantidad} de este producto, o null si no se supo.
// `lista`: las ubicaciones que existen (solo se propone una que exista).
export function sugerirDestino({ tipo, saldos, origen = '', ultima = '', lista = [] }) {
  const existe = (c) => Boolean(c) && lista.some((u) => u.codigo === c);
  const conExistencia = Object.entries(saldos || {})
    .filter(([c, n]) => Number(n) > 0 && existe(c))
    .sort((a, b) => Number(b[1]) - Number(a[1]))
    .map(([c]) => c);

  if (tipo === 'ENTRADA') {
    if (conExistencia.length) return conExistencia[0];
    return existe(ultima) ? ultima : '';
  }
  if (tipo === 'TRASPASO') {
    if (existe(ultima) && ultima !== origen) return ultima;
    return conExistencia.find((c) => c !== origen) || '';
  }
  return '';
}
